/* =====================================================================
 * Textarea — 공통 텍스트에리어 컴포넌트 (테마 기반)
 * ===================================================================== */

import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  fullWidth?: boolean;
  error?: boolean;
  resize?: 'none' | 'vertical' | 'horizontal' | 'both';
  minRows?: number;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ fullWidth = true, error, resize = 'vertical', minRows = 3, className, ...props }, ref) => (
    <StyledTextarea
      ref={ref}
      className={className}
      $fullWidth={fullWidth}
      $error={error}
      $resize={resize}
      rows={minRows}
      {...props}
    />
  ),
);

Textarea.displayName = 'Textarea';

const StyledTextarea = styled.textarea<{
  $fullWidth: boolean;
  $error?: boolean;
  $resize: string;
}>`
  padding: 10px 14px;
  border: 1px solid ${({ theme, $error }) => ($error ? theme.colors.error : theme.colors.borderInput)};
  border-radius: ${({ theme }) => theme.sizes.borderRadiusSm};
  background: ${({ theme }) => theme.colors.bgPrimary};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: 0.875rem;
  line-height: 1.5;
  outline: none;
  resize: ${({ $resize }) => $resize};
  min-height: 80px;
  transition: border-color ${({ theme }) => theme.transitions.fast};

  ${({ $fullWidth }) => $fullWidth && css`width: 100%;`}

  &:focus {
    border-color: ${({ theme }) => theme.colors.accent};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.textMuted};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
